module.exports = __webpack_public_path__ + "upload.png?6ac72f0f322981ed49b4c740a5fcbc72";